import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/site';

const benefits = [
  { icon: 'ri-search-eye-line', titleKey: 'home.benefit1Title', descKey: 'home.benefit1Desc' },
  { icon: 'ri-arrow-left-right-line', titleKey: 'home.benefit2Title', descKey: 'home.benefit2Desc' },
  { icon: 'ri-zoom-in-line', titleKey: 'home.benefit3Title', descKey: 'home.benefit3Desc' },
  { icon: 'ri-shield-check-line', titleKey: 'home.benefit4Title', descKey: 'home.benefit4Desc' },
];

export default function Benefits() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
      <div className="flex flex-col items-center text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{t('home.benefitsTitle')}</h2>
        <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">{t('home.benefitsSub')}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {benefits.map((b) => (
          <div key={b.titleKey} className="rounded-lg border border-background-200 bg-background-50 p-6">
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
              <i className={`${b.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-4 text-base font-semibold text-foreground-950">{t(b.titleKey)}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(b.descKey)}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 flex justify-center">
        <a
          href={MAIN_SITE_URL}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          {t('home.benefitCta')}
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-arrow-right-line text-lg"></i>
          </span>
        </a>
      </div>
    </section>
  );
}